import React, { useEffect } from "react";
import "./commonModal.css";

const CommonModal = ({ 
  isOpen, 
  onClose, 
  title, 
  message, 
  onConfirm, 
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel",
  showCancel = true,
  children 
}) => {
  // Close modal on ESC key press
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden"; // Prevent background scroll
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Handle backdrop click
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleBackdropClick}>
      <div className="modal-container">
        <div className="modal-content">
          {/* Title */}
          {title && <h2 className="modal-title">{title}</h2>}
          
          {/* Message */}
          {message && <p className="modal-message">{message}</p>}
          
          {children}
          {/* Action Buttons */}
          <div className="modal-actions">
            {showCancel && (
              <button 
                className="modal-btn modal-btn-cancel" 
                onClick={onCancel || onClose}
              >
                {cancelText}
              </button>
            )}
            <button 
              className="modal-btn modal-btn-confirm" 
              onClick={onConfirm}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonModal;